import { render } from "./DocumentPanelDialog.vue?vue&type=template&id=1e0891a2&scoped=true"
import script from "./DocumentPanelDialog.vue?vue&type=script&lang=js"
export * from "./DocumentPanelDialog.vue?vue&type=script&lang=js"

import "./DocumentPanelDialog.vue?vue&type=style&index=0&id=1e0891a2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0891a2"]])

export default __exports__